import '../../style/general/input/checkbox.css'
import {useState} from "react";
import {ReactComponent as TickIcon} from '../../../../res/icon/tick.svg';

const Checkbox = ({ isChecked: defaultChecked, onCheckedChange, alwaysUseIsChecked = false }) => {

    const [ isChecked, setChecked] = useState(defaultChecked);

    const handleClick = () => {
        if(!alwaysUseIsChecked) {
            setChecked(!isChecked);
        }
        onCheckedChange(!isChecked);
    }

    const displayChecked = alwaysUseIsChecked ? defaultChecked : isChecked;

    return (
        <div
            className={`checkbox-container${displayChecked ? " checked" : ""}`}
            onClick={handleClick}
        >
            {displayChecked && <TickIcon/>}
        </div>
    )

}

export default Checkbox;
